import { render, staticRenderFns } from "./OnboardingImportInstanceUrlSettingsModal.vue?vue&type=template&id=5f84ed59&scoped=true"
import script from "./OnboardingImportInstanceUrlSettingsModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportInstanceUrlSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportInstanceUrlSettingsModal.vue?vue&type=style&index=0&id=5f84ed59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84ed59",
  null
  
)

export default component.exports